import { Data, usePopup } from 'app/contexts/popup'
import { Row } from '@zera-admin/page'
import CustomModal from 'components/customModal'

const Popup: React.FunctionComponent<Data> = ({ children, id, ...rest }) => {
  const [popup] = usePopup()

  const handleClose = () => {
    if (id) {
      popup.remove(id)
    }
  }

  return (
    <CustomModal
      isOpen
      onClose={handleClose}
      title={rest.title}
      {...rest}
      style={
        {
          '--custom-modal-width': '350px',
        } as React.CSSProperties
      }
    >
      {children}
      <Row
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: '10px',
          marginTop: '10px',
        }}
      ></Row>
    </CustomModal>
  )
}

export default Popup
